import React, { forwardRef, ReactElement } from 'react'
import {
  Button as KittenButton,
  ButtonProps,
  Icon,
} from '@ui-kitten/components'
import { ActivityIndicator, View } from 'react-native'
import { useResponsive } from '../hooks'

export interface BtButtonProps extends ButtonProps {
  iconLeft?: string
  iconRight?: string
  loading?: boolean
  testID?: string
}

const LoadingIndicator = ({ evaProps, loading, accessoryLeft, color }) =>
  loading ? (
    <View
      style={[
        evaProps.style,
        { justifyContent: 'center', alignItems: 'center' },
      ]}
    >
      <ActivityIndicator size="small" color={color} />
    </View>
  ) : typeof accessoryLeft === 'function' ? (
    accessoryLeft()
  ) : (
    accessoryLeft
  )

export const BtButton = forwardRef<KittenButton, BtButtonProps>(
  (
    {
      loading = false,
      iconLeft,
      iconRight,
      accessoryLeft,
      size,
      ...rest
    }: BtButtonProps,
    ref: React.Ref<KittenButton>,
  ) => {
    const { sm } = useResponsive()

    // TBD: set fill & size based on button size and appearance
    const iconColor = rest.appearance === 'ghost' ? '#99ADBA' : '#FFFFFF'

    const iconLeftComponent = iconLeft ? (
      <Icon fill={iconColor} width={20} height={20} name={iconLeft} />
    ) : null

    const iconRightComponent = iconRight ? (
      <Icon fill={iconColor} width={20} height={20} name={iconRight} />
    ) : null

    return (
      <KittenButton
        accessoryLeft={(evaProps) => (
          <LoadingIndicator
            evaProps={evaProps}
            loading={loading}
            accessoryLeft={iconLeftComponent || accessoryLeft || null}
            color={rest.appearance === 'outline' ? '#00A0F3' : 'white'}
          />
        )}
        accessoryRight={iconRightComponent as ReactElement}
        size={size ? size : sm ? 'large' : 'medium'}
        ref={ref}
        {...rest}
      />
    )
  },
)
